import emailRegex from 'email-regex'

const genesysChatCustomForm = ({
  privacyPolicy,
  termsAndConditions,
}, user, dmpg) => {
  const sendErrorEvent = (id, name) => {
    dmpg.sendImmediately({
      event: "form.interact.auto.error.formError",
      form: {
        name: "genesys",
        fields: [{
          id,
          name,
          error: {
            code: '342',
            type: 'invalid data',
            message: 'Invalid value',
          },
        }],
      },
    })
  }

  return {
    subject: "Customer Satisfaction",
    wrapper: "<table></table>",
    inputs: [
      {
        id: "cx_webchat_form_firstname",
        name: "firstname",
        maxlength: "100",
        placeholder: "@i18n:webchat.ChatFormPlaceholderFirstName",
        label: "@i18n:webchat.ChatFormFirstName",
        value: user.isTravelAgent ? user.firstName : undefined,
        disabled: user.isTravelAgent,
        validate (event, form, input) {
          if (input && input.val()) {
            return true
          }

          sendErrorEvent("cx_webchat_form_firstname", "First Name")
          return false
        },
      },
      {
        id: "cx_webchat_form_lastname",
        name: "lastname",
        maxlength: "100",
        placeholder: "@i18n:webchat.ChatFormPlaceholderLastName",
        label: "@i18n:webchat.ChatFormLastName",
        value: user.isTravelAgent ? user.lastName : undefined,
        disabled: user.isTravelAgent,
        validate (event, form, input) {
          if (input && input.val()) {
            return true
          }

          sendErrorEvent("cx_webchat_form_lastname", "Last Name")
          return false
        },
      },
      {
        id: "cx_webchat_form_email",
        name: "email",
        maxlength: "100",
        placeholder: "@i18n:webchat.ChatFormPlaceholderEmail",
        label: "@i18n:webchat.ChatFormEmail",
        value: user.isTravelAgent ? user.email : undefined,
        disabled: user.isTravelAgent,
        validate (event, form, input) {
          if (input && input.val()
            && emailRegex({exact: true}).test(input.val())) {
            return true
          }

          sendErrorEvent("cx_webchat_form_email", "Email")
          return false
        },
      },
      {
        id: "cx_webchat_form_subject",
        name: "subject",
        maxlength: "100",
        placeholder: "@i18n:webchat.ChatFormPlaceholderSubject",
        label: "@i18n:webchat.ChatFormSubject",
      },
      {
        id: 'cx_webchat_form_disclaimer',
        name: 'disclaimer',
        type: 'checkbox',
        wrapper: '<tr><th>{input}</th><td>{label}</td></tr>',
        label: `By clicking "Start Chat" you are agreeing to our <a href="${privacyPolicy}" target="_blank">Privacy Policy</a> and <a href="${termsAndConditions}" target="_blank">Terms and Conditions</a>`,
      },
    ],
  }
}

export default genesysChatCustomForm
